export default function isNumber(s) {
    return s!==null && s!=='' && !isNaN(s);
}
